import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  WebGameColumn,
  WebGameMainCont,
  WebGameColumnInner,
  LeftContainerHeader,
} from '@pascal/pascal-core';

import Game from '../common/game';
import { doBetStore } from '../../store';
import RightColumn from '../common/rightColumn';
import { PopupsWrapper } from '../common/popupWrapper';
import { useDemoSwitcher } from '../../hooks/useDemoSwitcher';
import { useVisibilityChange } from '../../hooks/useVisibilityChange';
import fighterLogo from '../../assets/images/fighters-image/fighter-logo.png';
import playForRealPopupImgSrc from '../../assets/images/core/play-for-real-popup.png';

export const WebMainWrapper = observer(() => {
  const { demoSwitcherAdditionalFunction } = useDemoSwitcher();

  useVisibilityChange();

  return (
    <WebGameMainCont
      hasDemoPopup
      isShowBogLineLobby
      hasGameTypeLoading
      demoSwitcherAdditionalFunction={() => {
        demoSwitcherAdditionalFunction();
        doBetStore.resetDoBetData();
      }}
      playForRealPopupImgSrc={playForRealPopupImgSrc}
      lobbyLogoImageSrc={fighterLogo}
    >
      <LeftContainerHeader />
      <WebGameColumn position='center'>
        <WebGameColumnInner position='center'>
          <Game />
        </WebGameColumnInner>
        <PopupsWrapper />
      </WebGameColumn>
      <RightColumn />
    </WebGameMainCont>
  );
});
